import Scrollable from "../../Shared/Edit/Scrollable";
import ComponentToolbar from "./ComponentToolbar/ComponentToolbar";
import componentPropertiesMap from './ComponentFormProperties.json';
import { useChangeBooleans, useComponentProperties, useResetComponentProperties } from "../../../Hooks/Display/useComponentProperties";
import { useEffect, useState } from "react";
import { useSelectedComponent } from "../../../Hooks/Display/useComponents";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { usePropsStoreValue } from "../../../Hooks/PropStore/usePropsStore";

function StackedSection() {

    const formProperties = componentPropertiesMap.StackedSection;

    const selectedComponent = useSelectedComponent();
    const resetContext = useResetComponentProperties();
    const accessedFromDesigner = usePropsStoreValue("accessedFromDesigner");

    const [properties, setProperties] = useComponentProperties();
    const [, setChangeProperty] = useChangeBooleans();

    useEffect(() => {
        for (const property of formProperties) {
            if (
                selectedComponent[property] !== undefined
            ) {
                setProperties(property, selectedComponent[property])
            }
            setChangeProperty("isGeneralPropertiesChanged", false);
        }
        setInitializationDone(true);
    }, [])

    // componentWillUnmount
    useEffect(() => {
        return () => {
            resetContext();
        }
    }, [])

    const [initializationDone, setInitializationDone] = useState(false);
    useEffect(() => {
        if (initializationDone) {
            setIsChanged();
        }
    }, [properties]);

    // state
    const [tabSelected, setTabSelected] = useState(0);

    // functions
    function handleLabel(event) {
        setProperties("label", event.target.value);
    }

    function setIsChanged() {
        let isChanged = false;
        for (const property of formProperties) {
            if (selectedComponent[property] !== properties[property]) {
                isChanged = true;
                break;
            }
        }
        setChangeProperty("isGeneralPropertiesChanged", isChanged);
    }

    // handlers
    function handleTabSelect(event) {
        setTabSelected(event.selected);
    }

    return (
        <div className={"h-100 d-flex flex-column line" + (!accessedFromDesigner && " runtimePopup")}>
            <ComponentToolbar />
        </div>
    )
}

export default StackedSection;